import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import * as z from "zod";
import { canProcessReturn } from "../../returns/return-action-eligibility";
import { defineReturnAction } from "../types";

/** Everything else uses the process modal's defaults, computed server-side. */
const BulkProcessPayloadSchema_ = z.object({ notifyCustomer: z.boolean() });
export interface ProcessPayload extends z.infer<
  typeof BulkProcessPayloadSchema_
> {}

export const processReturnAction = defineReturnAction<ProcessPayload>({
  label: "Process",
  permissions: [ReturnsAndClaimsPermissions.PROCESS_RETURN],
  irreversible: true,
  isEligible: ({ return_ }) => canProcessReturn({ return_ }),
  payloadSchema: BulkProcessPayloadSchema_,
  examplePayload: { notifyCustomer: true },
});
